import { BankAccountType } from '@/schema'
import { z } from 'zod'

export const BANK_ACCOUNT_TYPES = [
	{ value: BankAccountType.DEPOSIT, label: 'ฝาก' },
	{ value: BankAccountType.WITHDRAWAL, label: 'ถอน' },
	{ value: BankAccountType.DEPOSIT_WITHDRAWAL, label: 'ฝาก-ถอน' },
	{ value: BankAccountType.TRANSFER, label: 'พักเงิน' },
] as const

export const VALIDATION_TYPES = [
	{ value: 'SMS', label: 'SMS' },
	{ value: 'BANK_API', label: 'Bank API' },
	{ value: 'BANK_APP', label: 'Bank App' },
] as const

export const formSchema = z
	.object({
		accountName: z.string().min(1, 'กรุณากรอกชื่อบัญชี'),
		accountNumber: z.string().min(10, 'กรุณากรอกเลขบัญชีที่ถูกต้อง'),
		bankProvider: z.string().min(1, 'กรุณากรอกชื่อธนาคาร'),
		bankType: z.nativeEnum(BankAccountType, {
			required_error: 'กรุณาเลือกประเภทบัญชี',
		}),
		isActive: z.boolean().default(true),
		validateType: z
			.array(z.enum(['SMS', 'BANK_API', 'BANK_APP']))
			.min(1, 'กรุณาเลือกประเภทการตรวจสอบอย่างน้อย 1 รายการ'),
		bankApiCredential: z
			.object({
				username: z
					.string({ required_error: 'กรุณากรอก username' })
					.min(1, 'กรุณากรอก username'),
				password: z
					.string({ required_error: 'กรุณากรอก password' })
					.min(1, 'กรุณากรอก password'),
			})
			.optional()
			.refine(
				(data) => {
					if (!data) return true
					return data.username !== '' && data.password !== ''
				},
				{
					message: 'กรุณากรอก username และ password',
				},
			),
		appCredential: z
			.object({
				deviceId: z
					.string({ required_error: 'กรุณากรอก Device ID' })
					.min(1, 'กรุณากรอก Device ID'),
				pin: z
					.string({ required_error: 'กรุณากรอก PIN' })
					.min(1, 'กรุณากรอก PIN'),
			})
			.optional()
			.refine(
				(data) => {
					if (!data) return true
					return data.deviceId !== '' && data.pin !== ''
				},
				{
					message: 'กรุณากรอก Device ID และ PIN',
				},
			),
	})
	.refine(
		(data) => {
			if (data.validateType.includes('BANK_API')) {
				return (
					data.bankApiCredential?.username && data.bankApiCredential?.password
				)
			}
			return true
		},
		{
			message: 'กรุณากรอก username และ password สำหรับ Bank API',
			path: ['bankApiCredential'],
		},
	)
	.refine(
		(data) => {
			if (data.validateType.includes('BANK_APP')) {
				return data.appCredential?.deviceId && data.appCredential?.pin
			}
			return true
		},
		{
			message: 'กรุณากรอก Device ID และ PIN สำหรับ Bank App',
			path: ['appCredential'],
		},
	)

export type FormValues = z.infer<typeof formSchema>
